export default __webpack_public_path__ + "0da70a12f6f2ce61fae05ff34b8e0528.png";